module.exports = __webpack_public_path__ + "static/img/1_1.4235fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/1_1.png
// module id = Q3N6
// module chunks = 44